import { useEffect } from 'react';

/**
 * Hook to set the document title for SEO purposes
 * @param title - The title to set for the page
 * @param restoreOnUnmount - Whether to restore the previous title when component unmounts (default: true)
 */
export const useDocumentTitle = (title: string, restoreOnUnmount = true) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    return () => {
      if (restoreOnUnmount) {
        document.title = previousTitle;
      }
    };
  }, [title, restoreOnUnmount]);
};
